<template>
    <div>
        <div>
            <div class="plugins-tips">
                <el-input v-model="query.noticeSearch" placeholder="Filter" @keyup.enter.native="handleUserSearch"
                    class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleUserSearch">搜索</el-button>
                <span style="margin-left: 20px; color: #67C23A; font-size: 15px"></span>
                <el-button style="float: right;margin-right: 100px;" type="primary"
                    @click="exportExcelMethod">导出Excel表格</el-button>
            </div>
            <el-table :data="user.tableData" @row-click="rowNoticeClick" :header-cell-style="{ 'text-align': 'center' }"
                v-loading="user.loading" stripe>
                <el-table-column prop="tradeNo" label="订单号" align="center"></el-table-column>
                <el-table-column prop="userId" label="用户Id" align="center"></el-table-column>
                <el-table-column prop='productId' label='商品Id' align='center'></el-table-column>
                <el-table-column prop="projectName" label="所属项目" align="center"></el-table-column>
                <el-table-column prop="subject" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="buyerId" label="买家账号" align="center"></el-table-column>
                <el-table-column prop="receiptAmount" label="实收金额" align="center"></el-table-column>
                <el-table-column prop="buyerPayAmount" label="付款金额" align="center"></el-table-column>
                <el-table-column prop="gmtPayment" label="付款时间" align="center"></el-table-column>
                <el-table-column prop="gmtCreate" label="交易创建时间" align="center"></el-table-column>
                <el-table-column prop="operation" label="操作" align="center">
                    <template slot-scope="scope">
                        <router-link target="_blank"
                            :to="{ path: 'AlipayOperation', query: { refundOrderNo: scope.row.tradeNo, price: scope.row.receiptAmount } }">
                            <el-button type="primary">
                                退款
                            </el-button>
                        </router-link>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="user.pageIndex"
                    :page-size="user.pageSize" :total="user.pageTotal"
                    @current-change="handleUserPageChange"></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { exportExcelAlipayOrder, selAlipayOrderInfo } from '../../../api/pay.js';
import fileDownload from 'js-file-download';

export default {
    name: 'AlipayRecord',
    data: function () {
        return {
            query: {
                noticeSearch: '',  //公告搜索
            },
            user: {
                tableData: [],
                pageIndex: 1,
                pageSize: 10,
                pageTotal: 1,
                loading: false
            },
        }
    },
    created() {
        this.initUserData()
    },
    activated() {
        this.initUserData()
    },
    methods: {
        exportExcelMethod() {
            this.$confirm('是否确定导出excel文件?', "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                //发送请求
                exportExcelAlipayOrder().then(res => {
                    fileDownload(res.data,"orderRecord.xls")
                }).catch(err => {

                })
            }).catch(() => { })
        },

        //初始化数据
        initUserData() {
            this.user.loading = true
            //如果搜索框不等于 空, 添加搜索条件
            let noticeId = null;
            if (this.query.noticeSearch != '' && this.query.noticeSearch != undefined) {
                noticeId = this.query.noticeSearch
            }
            //发送请求
            let params = { 'tradeNo': noticeId, 'startPage': this.user.pageIndex, 'pageCount': this.user.pageSize }
            selAlipayOrderInfo(params).then(res => {
                if (res.status == 200) {
                    this.user.tableData = res.data.data.records;
                    this.user.pageTotal = res.data.data.total;
                }
                this.user.loading = false
            }).catch(err => {
                this.user.loading = false
            })
        },

        //row点击  进入编辑页
        rowNoticeClick(row, column) {
            if (column.label != '内容') return
            this.$router.push({
                path: `/Notice/${row.id}`
            })
        },

        //搜索框
        handleUserSearch() {
            this.user.pageIndex = 1;
            this.initUserData()
        },

        //上一页 or 下一页
        handleUserPageChange(pageIndex) {
            this.user.pageIndex = pageIndex
            this.initUserData()
        },
    }
}
</script>

<style scoped lang="scss">
/* 鼠标悬浮 */
::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td {
    //  background-color: #212e3e !important;
    cursor: pointer;
}

.handle-input {
    width: 260px;
    display: inline-block;
    margin-right: 10px;
}
</style>
